import { FC } from 'react';
import styled, { keyframes } from 'styled-components';

type LoaderProps = {
  size?: number;
  bgColor?: string;
  margin?: string;
  color?: string;
};

export const Loader: FC<LoaderProps> = ({ size = 11, bgColor = '#fff', margin = '55px auto', color = '#3899ec' }) => {
  return <LoaderContainer size={size} bgColor={bgColor} margin={margin} color={color} />;
};

const load = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const LoaderContainer = styled.div<{ size: number; bgColor: string; margin: string; color: string }>`
  border-radius: 50%;
  color: ${(p) => p.color};
  font-size: ${(p) => p.size}px;
  text-indent: -99999em;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 0.5em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  margin: ${(p) => p.margin};

  &::before,
  &::after {
    content: '';
    position: absolute;
    border-radius: 50%;
  }

  &::before {
    width: 5.2em;
    height: 10.2em;
    background: ${(p) => p.bgColor};
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    transform-origin: 5.1em 5.1em;
    animation: ${load} 2s infinite ease 1.5s;
  }

  &::after {
    width: 5.2em;
    height: 10.2em;
    background: ${(p) => p.bgColor};
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 4.9em;
    transform-origin: 0.1em 5.1em;
    animation: ${load} 2s infinite ease;
  }
`;
